// extracted by mini-css-extract-plugin
export default {"sub-menu-title":"HorizontalLayout_sub-menu-title__xLhr8","nav":"HorizontalLayout_nav__l2I7d"};